<template>
<div class="modal-mask-pause background-rhythm">
    <div class="modal-wrapper-pause">
        <div class="modal-container-pause">
             <div class="close tamanhoicon" @click="$emit('closeModal')">
                 <img :src="require('@/assets/buttons/newbuttons/rhythm/close.svg')" />
            </div>
            <div class="modal-header-pause tamanhotitle">
                <slot name="header">
                    PAUSE
                </slot>
            </div>
            <div class="modal-body-pause">
                <div class="label-style-pause tamanho0"> 
                    <span>Restart</span>
                    <span>Resume</span>
                </div>
                <slot name="body">
                    <div class="tamanhoicon" @click="$emit('restart')">
                        <img :src="require('@/assets/buttons/newbuttons/rhythm/restart.svg')" />
                    </div>
                    <div class="tamanhoicon" @click="$emit('resume')">
                        <img :src="require('@/assets/buttons/newbuttons/rhythm/play.svg')" />
                    </div>
                   
                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "PauseModal",
    emits: ['closeModal', 'restart','resume'],
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>


</style>
